import api from "@/apis/system"


//权限校验
let promise = Promise.resolve()
let permissions = () => {
    promise = promise.then(() => {
        if (!localStorage.getItem("permiss")) {
            return api.auth.actions()
        }

    }).then((res) => {
        if (res) {
            localStorage.setItem("permiss", JSON.stringify(res))
        }
    })
    return JSON.parse(localStorage.getItem("permiss"));
}
export default {
    inserted: function (el, binding) {
        if (!permissions().includes(binding.value)) {
            el.remove()
            el.parentNode && el.parentNode.removeChild(el)
        }
    }
}